export const upgradeRequired = (
  <>
    You have exceeded your monthly credit limit. Please upgrade your plan to continue using Jitsu. As a courtesy, we
    keep sending your data to destinations, but we can stop doing so at any moment
  </>
);
